// removed by extract-text-webpack-plugin
module.exports = {"batch-send-item-stats":"BatchSentItemStats__batch-send-item-stats___3hle9"};